<template lang="pug">
  .sinature.page
</template>

<script>
import { curUrl, getURLParameters } from '@/utils'
import { mapActions } from 'vuex'

export default {
  name: 'signature',
  async created() {
    // http://localhost:9094/signature?videoid=1134&access_token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTA5ODQsImlhdCI6MTU1MzY1NTA1MH0.rgCjJ5SgS2LQlSlugll-Zlq65ZOGtjYOmd7PPby0QIQ&expires_in=86400
    // const data = await getHrefData(href)
    // const videoId = href.split('?videoid=')[1]
    // saveUserInfo(data)
    // this.$router.push(`/?videoid=${videoId}`)
  },
  mounted() {
    const r = getURLParameters(curUrl())
    const token = r.access_token
    const videoid = r.videoid
    this.wxAuthSignin({ token, videoid })
  },
  methods: {
    ...mapActions({
      wxAuthSignin: 'WX_SIGN_IN',
    }),
  },
}
</script>
